exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dtlp-trip-proposal-list {\n  border: 1px solid #808080;\n  border-radius: 4px;\n  padding-bottom: 8px;\n  background-color: #c2bbba;\n  -webkit-transition: border-radius 200ms, padding-bottom 200ms, border-width 200ms;\n  transition: border-radius 200ms, padding-bottom 200ms, border-width 200ms;\n}\n.dtlp-trip-proposal-list--has-no-items {\n  border-radius: 0;\n  padding-bottom: 0;\n  border-width: 0;\n}\n", ""]);

// exports
